import LandingPageContainer from './containers/LandingPageContainer'

export default LandingPageContainer
